import { OnInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { WizardCreateComponent } from 'app/orders/wizard/create/create.component';
import { WizardService } from 'app/orders/wizard/wizard.service';
import { camelCase } from 'app/core/case-transform';
import { PersonalizedLocalStorageService } from 'app/notifications/personalized-local-storage.service';
var WizardUploadComponent = /** @class */ (function () {
    function WizardUploadComponent(_settings, _angulartics2, _dialogService, _wizardService, _userSettingsService, _personalizedLocalStorageService) {
        this._settings = _settings;
        this._angulartics2 = _angulartics2;
        this._dialogService = _dialogService;
        this._wizardService = _wizardService;
        this._userSettingsService = _userSettingsService;
        this._personalizedLocalStorageService = _personalizedLocalStorageService;
        this.isLoading = false;
        this.templateError = 'Error';
        this.templateErrorDescription = 'Error of processing of parameters';
    }
    Object.defineProperty(WizardUploadComponent.prototype, "uploadedFiles", {
        get: function () {
            return this._wizardService.statistics.files;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUploadComponent.prototype, "skipCreateDialog", {
        get: function () {
            return this._settings.skipCreateDialog;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUploadComponent.prototype, "showCreateDialog", {
        get: function () {
            return !this.skipCreateDialog;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUploadComponent.prototype, "canShowSettings", {
        get: function () {
            return this._settings.showSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUploadComponent.prototype, "canStartProcess", {
        get: function () {
            return !this.isLoading && this.filesReady();
        },
        enumerable: true,
        configurable: true
    });
    WizardUploadComponent.prototype.ngOnInit = function () {
        this.files = this._wizardService.files;
        var taskPropertiesLocalStorage = this._personalizedLocalStorageService.getJson('order_properties');
        if (taskPropertiesLocalStorage && taskPropertiesLocalStorage.length > 0) {
            this.orderSettingsDc = Object.assign([], taskPropertiesLocalStorage);
        }
        else {
            this.orderSettingsDc = [];
        }
        this.orderSettings = Object.assign({}, this._userSettingsService.orderSettings);
    };
    WizardUploadComponent.prototype.showSettings = function () {
        this._openSettingsDialog();
    };
    WizardUploadComponent.prototype.next = function () {
        this._openSettingsDialog();
    };
    WizardUploadComponent.prototype.filesReady = function () {
        return this._wizardService.filesReady();
    };
    WizardUploadComponent.prototype.startProcess = function () {
        this._createOrder();
    };
    WizardUploadComponent.prototype.removeFile = function (file) {
        this._wizardService.removeFile(file);
    };
    WizardUploadComponent.prototype.uploadFiles = function (files) {
        this._wizardService.upload(files);
    };
    WizardUploadComponent.prototype._createOrder = function () {
        var _this = this;
        this.onHideError();
        this.isLoading = true;
        var data = {};
        try {
            if (this.isIc()) {
                (data.verification = this.orderSettings.verificationType),
                    (data.export_format = this.orderSettings.exportFormat);
                data.region = this.orderSettings.region;
            }
            else {
                var _temp = this.orderSettingsDc.reduce(function (acc, cur, _i) {
                    if (cur.name && cur.name !== '') {
                        acc[cur.name] = cur.value || '';
                    }
                    return acc;
                }, {});
                Object.assign(data, _temp);
            }
            this._wizardService
                .create(data, this._userSettingsService.serviceType)
                .subscribe(function (order) {
                _this._personalizedLocalStorageService.setJson('order_properties', _this.orderSettingsDc);
                var properties = {
                    event: 'Create Order',
                    'Service Type': order.serviceType,
                    'Document Count': _this._wizardService.files.length,
                    'Export Format': _this.orderSettings.exportFormat,
                    'Invoice Region': _this.orderSettings.region,
                    'Verification Type': _this.orderSettings.verificationType,
                    Number: order.number
                };
                if (!_this.isIc()) {
                    delete properties['Invoice Region'];
                }
                _this._angulartics2.eventTrack.next({
                    action: 'Create Order',
                    properties: properties
                });
                _this._wizardService.reset();
                _this._dialogService.close();
            }, function (error) { return _this._onError(error); });
        }
        catch (error) {
            data = {};
            this.error = this.templateError;
            this.errorDescription = this.templateErrorDescription;
            console.error(error);
            this.isLoading = false;
        }
    };
    WizardUploadComponent.prototype.isIc = function () {
        return this._userSettingsService.serviceType === 'ic';
    };
    WizardUploadComponent.prototype.onHideError = function () {
        this.error = null;
        this.errorDescription = null;
    };
    WizardUploadComponent.prototype._onError = function (response) {
        if (response.status === 400) {
            var responseJson = response.json();
            this.error = camelCase(responseJson.error);
            this.errorDescription = this._getErrorDescription(responseJson);
        }
        else {
            this.error = this.templateError;
            this.errorDescription = this.templateErrorDescription;
        }
        this.isLoading = false;
    };
    WizardUploadComponent.prototype._getErrorDescription = function (responseJson) {
        var modelState = responseJson.modelState;
        if (!modelState) {
            return responseJson.errorDescription;
        }
        return Object.keys(modelState)
            .map(function (fieldName) { return modelState[fieldName].join('\n'); })
            .join('\n');
    };
    WizardUploadComponent.prototype._openSettingsDialog = function () {
        this._settings.isFilesReady = this.filesReady();
        this._dialogService.open(WizardCreateComponent, { data: this._settings });
    };
    WizardUploadComponent.prototype.onKeydownHandler = function (event) {
        if (event.keyCode === 13) {
            if (this.skipCreateDialog) {
                if (this.canStartProcess) {
                    this.startProcess();
                }
            }
            else {
                if (this.filesReady()) {
                    this.next();
                }
            }
        }
    };
    return WizardUploadComponent;
}());
export { WizardUploadComponent };
